import React, {useEffect, useState} from 'react';
import SideMenu from "Components/SideMenu";
import Breadcrumb from "Components/Breadcrumb";
import {Pagination} from "@mui/material";
import * as Apis from "../../Api";
import moment from "moment";
import {useNavigate} from "react-router-dom";
import {lawInfoList} from "../../Api";

function LawInfo() {
    const navigate = useNavigate();
    const [itemList, setItemList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPageCount, setTotalPageCount] = useState(0);
    const [totalItemCount, setTotalItemCount] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(9);

    useEffect(() => {
        getData();
    }, [currentPage]);

    const getData = () => {
        Apis.lawInfoList(currentPage, itemsPerPage).then((resp) => {
            setItemList(resp.data);
            setCurrentPage(resp.meta.currentPage);
            setTotalPageCount(resp.meta.totalPageCount);
            setTotalItemCount(resp.meta.totalItemCount);
            setItemsPerPage(resp.meta.itemsPerPage);
        }).catch((e) => {
            console.error(e);
        });
    }

    const onClickItem = (itemId, index) => {
        navigate('/law-info/view', {state: {side: '법률정보', itemIndex: index, itemList: itemList.map((v) => v.id)}});
    }

    const renderItem = (item, index) => {
        return (
            <div key={item} className={'law-item'} onClick={() => onClickItem(item.id, index)}>
                <img src={Apis.imageBasePath + item.issueImage} alt=''/>
                <div className={'flex-fill p-3 d-flex flex-column justify-content-between'}>
                    <div>
                        <div className={'law-item-title'}>{item.issueTitle}</div>
                        <div className={'law-item-content'}>
                            {item.issueContent}
                        </div>
                    </div>
                    <div className={'law-item-time'}>{moment(item.createdAt).format('YYYY-MM-DD')}</div>
                </div>
            </div>
        )
    }

    return (
        <div className={'page-center'}>
            <SideMenu title={'법률정보'} menu={[]}/>
            <div className={'page-content law-info-container'}>
                <Breadcrumb value={['홈', '법률정보']}/>
                <span className={'fs-12 text-desc1'}>전체 {totalItemCount}</span>
                <div className={'law-info-list'}>
                    {
                        itemList.map((v, i) => renderItem(v, i))
                    }
                </div>
                <div className={'d-flex justify-content-center mt-4'}>
                    <Pagination
                        color={'primary'}
                        shape={'rounded'}
                        count={totalPageCount}
                        page={currentPage}
                        onChange={(e, page) => setCurrentPage(page)}
                    />
                </div>
            </div>
        </div>
    )
}

export default LawInfo;